import { render, staticRenderFns } from "./BinListingComponent.vue?vue&type=template&id=ae238d4a"
import script from "./BinListingComponent.vue?vue&type=script&lang=js"
export * from "./BinListingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports